import { AnimatePresence, domAnimation, LazyMotion, m } from "framer-motion";

const CollapsibleContainer = ({ children, expanded, animatePresence }) => {
  const variants = {
    expanded: {
      height: "auto",
      opacity: 1,
      pointerEvents: "auto",
      userSelect: "auto",
    },
    collapsed: {
      height: 0,
      opacity: 0,
      pointerEvents: "none",
      userSelect: "none",
      overflow: "hidden",
    },
  };

  return (
    <LazyMotion features={domAnimation}>
      {animatePresence ? (
        <AnimatePresence>
          {expanded && (
            <m.div
              initial={variants["collapsed"]}
              animate={variants["expanded"]}
              exit={variants["collapsed"]}
              transition={{ duration: 0.2 }}
            >
              {children}
            </m.div>
          )}
        </AnimatePresence>
      ) : (
        <m.div
          initial={false}
          animate={variants[expanded ? "expanded" : "collapsed"]}
          transition={{ duration: 0.2 }}
        >
          {children}
        </m.div>
      )}
    </LazyMotion>
  );
};

export default CollapsibleContainer;
